import { FC } from 'react';
import { AppTags } from '../../interfaces/domain/ow-app.modal';
import OWLink from '../shared/ow-link';

// -----------------------------------------------------------------------------
interface TagProps {
  list: AppTags[];
}

// -----------------------------------------------------------------------------
export const TagList: FC<TagProps> = ({ list }): JSX.Element => {

  return (
    <>
      {list.map((tagItem, index) => {
        const className = tagItem.url ? 'tag-item-link' : 'tag-item';

        return (
          <li className={className} key={index}>
            {tagItem.url &&
                <OWLink href={tagItem.url}>
                  {tagItem.name}
                </OWLink>
            }
            {!tagItem.url &&
                tagItem.name
            }
          </li>
        );

      })}
    </>
  );
};
